import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyConfig } from '../config/company';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Información de la empresa */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img
                src="/images/logo.jpg"
                alt="Plásticos Polcen"
                className="h-10 w-10 rounded-lg object-cover"
              />
              <span className="ml-3 text-xl font-bold">Plásticos Polcen</span>
            </div>
            <p className="text-gray-300 text-sm">
              desde el año 2013 en la fabricación de bolsas de plástico LDPE personalizadas. 
              Calidad, confiabilidad y servicio personalizado.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/PlasticosPolcen" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-400 hover:text-white transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/polcenplast/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-400 hover:text-white transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-400 hover:text-white transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/productos" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Productos
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/empresa" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Empresa
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Productos */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Productos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/productos?category=comercial" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Bolsas Comerciales
                </Link>
              </li>
              <li>
                <Link to="/productos?category=industrial" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Bolsas Industriales
                </Link>
              </li>
              <li>
                <Link to="/productos?category=domestico" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Bolsas Domésticas
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Cotización Personalizada
                </Link>
              </li>
            </ul>
          </div>

          {/* Información de contacto */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Contacto</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin className="h-5 w-5 text-primary-400 mt-0.5 mr-3 flex-shrink-0" />
                <div className="text-sm text-gray-300">
                  <p>Santiago de Liniers 1239</p>
                  <p>Rivadavia, San Juan</p>
                  <p>Argentina</p>
                  <a
                    href={companyConfig.googleMapsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-2 text-primary-300 hover:text-primary-200 transition-colors"
                  >
                    Ver perfil en Google Maps
                  </a>
                </div>
              </div>
              
              <div className="flex items-center">
                <Phone className="h-5 w-5 text-primary-400 mr-3 flex-shrink-0" />
                <a href="tel:+542644114422" className="text-sm text-gray-300 hover:text-white transition-colors">
                  (264) 411-4422
                </a>
              </div>
              
              <div className="flex items-center">
                <Mail className="h-5 w-5 text-primary-400 mr-3 flex-shrink-0" />
                <a href="mailto:plasticospolcen@gmail.com" className="text-sm text-gray-300 hover:text-white transition-colors">
                  plasticospolcen@gmail.com
                </a>
              </div>
              
              <div className="flex items-start">
                <Clock className="h-5 w-5 text-primary-400 mt-0.5 mr-3 flex-shrink-0" />
                <div className="text-sm text-gray-300">
                  <p>Lunes a Viernes</p>
                  <p>08:00 - 17:00</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-400">
              © 2024 Plásticos Polcen. Todos los derechos reservados.
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/politica-privacidad" className="text-sm text-gray-400 hover:text-white transition-colors">
                Política de Privacidad
              </Link>
              <Link to="/terminos-condiciones" className="text-sm text-gray-400 hover:text-white transition-colors">
                Términos y Condiciones
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 px-4 py-2.5 text-center text-xs text-gray-400">
        Diseño y desarrollo por Esteban Lucero ·{' '}
        <a
          href="https://appteck.com.ar"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-gray-300 transition-colors hover:text-white"
        >
          Appteck
        </a>
      </div>
    </footer>
  );
};

export default Footer;






